<div class="w-full flex justify-center items-start bg-[#2a3a6c] py-8 px-4 pt-16">
  <!-- Change Password Form -->
  <div id="changePassword" class="w-full max-w-lg mx-auto" *ngIf="!passwordChanged">
    <div class="form-container">
      <div class="form-header">
        <h2 class="form-title">Change Password</h2>
        <p class="form-subtitle">Enter your current password and choose a new one.</p>
      </div>
      <form [formGroup]="changePasswordForm" (ngSubmit)="onChangePassword()" class="form-body">
        <div class="form-field">
          <label for="oldPassword" class="form-label">Old Password</label>
          <div class="form-field-input-wrapper">
            <input 
              id="oldPassword" 
              type="password" 
              formControlName="oldPassword" 
              class="form-input" 
              required />
          </div>
        </div>
        <div class="form-field">
          <label for="newPassword" class="form-label">New Password</label>
          <div class="form-field-input-wrapper">
            <input 
              id="newPassword" 
              type="password" 
              formControlName="newPassword" 
              class="form-input" 
              required />
          </div>
        </div>
        <div class="form-field">
          <label for="reNewPassword" class="form-label">Re-enter New Password</label>
          <div class="form-field-input-wrapper">
            <input 
              id="reNewPassword" 
              type="password" 
              formControlName="reNewPassword" 
              class="form-input" 
              required />
          </div>
        </div>
        <div class="pt-4">
          <button 
            type="submit" 
            class="form-button form-button-primary w-full"
            [disabled]="!changePasswordForm.valid">
            Change Password
          </button>
        </div>
      </form>
    </div>
  </div>

  <!-- Success Message -->
  <div id="passwordChanged" class="w-full max-w-lg mx-auto" *ngIf="passwordChanged">
    <div class="form-container">
      <div class="form-header">
        <div class="flex justify-center mb-4">
          <img src="{{'assets/img/correct.png'}}" class="w-24 h-24 object-contain" alt="Success">
        </div>
        <h2 class="form-title">Password Changed Successfully</h2>
        <p class="form-subtitle">Your password has been updated.</p>
      </div>
      <div class="form-body">
        <div class="flex justify-center pt-4">
          <a 
            routerLink="/courses" 
            class="form-button form-button-primary inline-block text-center">
            Done
          </a>
        </div>
      </div>
    </div>
  </div>
</div>